export const teamCodes = {
  onlineApplication: {
    responsibleTeam: "HAPP",
    responsibleUser: "1070551",
  },
};

export const statusCodes = {
  COMPLETED: { status: 1, iconName: "done", iconColor: "success" },
  NOT_STARTED: { status: 0, iconName: "error", iconColor: "danger" },
  IS_REQUIRED: { iconName: "warning", iconColor: "info" },
  CONTINUAL: { status: -1, iconName: "info", iconColor: "info" },
};
